import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { signOutRequest } from '@store/auth'

interface IAuthSignOutRedirectProps {
  signOutRequest: typeof signOutRequest
  history: any
}

// Base component for testing
export const AuthSignOutRedirect: React.FC<IAuthSignOutRedirectProps> = ({
  signOutRequest: signOutRequestAction,
  history,
}) => {
  useEffect(() => {
    signOutRequestAction({
      history,
      redirect: '/',
    })
  }, [])

  return null
}

// Connected component for production
const ConnectedAuthSignOutRedirect: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  return (
    <AuthSignOutRedirect
      signOutRequest={(meta) => dispatch(signOutRequest(meta))}
      history={history}
    />
  )
}

export default ConnectedAuthSignOutRedirect
